
const store: any = {};

export function buildCache<T>(namespace: string) {
  // Initialize the in memory cache and link back to the global store so all changes are being made by reference.
  if (!store[namespace]) {
    store[namespace] = {};
  }

  return {
    cache: store[namespace],
    all(): Array<T> {
      const data: Array<T> = [];
      const keys = Object.keys(this.cache);
      for (let key of keys)
        data.push(this.cache[key]);
      return data;
    },
    clear() {
      store[namespace] = {};
      this.cache = store[namespace];
    },
    get(key: string): T | null {
      return this.cache[key] || null;
    },
    set(key: string, value: T) {
      this.cache[key] = value;
    }
  };
};